import client from "./client";

export const fetchVerifyAttempts = async (filters) =>
  (await client.get("/reports/verify-attempts", { params: filters })).data;

export const exportVerifyAttempts = async (kind, lang, filters) => {
  const res = await client.get("/reports/verify-attempts/export", {
    params: { kind, lang, ...filters },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = `verify-attempts.${kind}`;
  link.click();
  window.URL.revokeObjectURL(url);
};
